import {
  AddAppAccountRequestPayload,
  TermsConsent,
} from "@/data/payload/app-account-setting/add-app-account-request-payload";
import { CheckUserIdAvailableRequestPayload } from "@/data/payload/app-account-setting/check-user-id-available-request-payload";
import { AppAccountSettingSource } from "@/data/source/app-account-setting-source";
import {
  AppAccountSettingRepository,
  ParentalConsentInfo,
} from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class AppAccountSettingRepositoryImpl implements AppAccountSettingRepository {
  constructor(private readonly source: AppAccountSettingSource) {}

  setAuthorizedToken(token: string): Promise<SATResult<void, SATError>> {
    return this.source.setAuthorizedToken(token);
  }

  isExistAuthorizedToken(): Promise<boolean> {
    return this.source.isExistAuthorizedToken();
  }

  removeAuthorizedToken(): Promise<void> {
    return this.source.removeAuthorizedToken();
  }

  saveTermsConsent(termsConsent: TermsConsent[]): Promise<SATResult<void, SATError>> {
    return this.source.saveTermsConsent(termsConsent);
  }

  checkUserNameBySmsTokenForLoginAccount(name: string): Promise<SATResult<void, SATError>> {
    return this.source.checkUserNameBySmsTokenForLoginAccount(name);
  }

  checkUserIdAvailable(payload: CheckUserIdAvailableRequestPayload): Promise<SATResult<void, SATError>> {
    return this.source.checkUserIdAvailable(payload);
  }

  addAppAccount(payload: AddAppAccountRequestPayload): Promise<SATResult<void, SATError>> {
    return this.source.addAppAccount(payload);
  }

  fetchPrivayMdFile(locale: string): Promise<SATResult<ParentalConsentInfo, SATError>> {
    return this.source.fetchPrivayMdFile(locale);
  }

  fetchTermsOfServiceFile(locale: string): Promise<SATResult<ParentalConsentInfo, SATError>> {
    return this.source.fetchTermsOfServiceFile(locale);
  }
}
